import { Container, Point } from 'pixi.js';

export class LayerReparentHelper {
    static moveToLayer(object: Container, fromContainer: Container, targetLayer: Container, stage: Container): Container {
        const { x, y, width, height } = object;
        const placeholder = new Container({ x, y, width, height, parent: stage });
        const index = fromContainer.getChildIndex(object);
        fromContainer.addChildAt(placeholder, index);
        const worldPosition = object.getGlobalPosition(new Point());
        const localPosition = targetLayer.toLocal(worldPosition);
        targetLayer.addChild(object);
        object.position.set(localPosition.x, localPosition.y);
        return placeholder;
    }

    static restoreToContainer(object: Container, targetContainer: Container, index: number, placeholder?: Container | null): void {
        const worldPosition = object.getGlobalPosition(new Point());
        const localPosition = targetContainer.toLocal(worldPosition);
        targetContainer.addChildAt(object, index);
        object.position.set(localPosition.x, localPosition.y);
        placeholder?.destroy();
    }
}
